import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  ResetDetails: {},
  isLoading: false,
  error: {},
  isSuccess: false,
  isError: false,
  hasData: false
};
const resetCorporateSlice = createSlice({
  name: "resetCorporate",
  initialState,
  reducers: {
    resetDataCorporateRequest: (state, action) => {
      state.isLoading = true;
      state.error = "";
      state.hasData = false;
      state.isSuccess = false;
      state.isError = false;
      state.ResetDetails = {};
    },
    resetDataCorporateSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.ResetDetails = action.payload;
      state.isSuccess = true;
      state.isError = false;
    },
    resetDataCorporateFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.hasData = false;
      state.ResetDetails = {};
      state.isSuccess = false;
      state.isError = true;
    }
  }
});
export const {
  resetDataCorporateFailure,
  resetDataCorporateRequest,
  resetDataCorporateSuccess
} = resetCorporateSlice.actions;
export default resetCorporateSlice.reducer;